import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import "../css/AppointmentNotification.css";
import { getISTDateInputValue } from "../utils/dateTime";

const AppointmentNotification = () => {

    const [showDropdown, setShowDropdown] = useState(false);
    const [appointments, setAppointments] = useState([]);

    useEffect(() => {

        const loadTodayAppointments = async () => {

            try {

                const localDate = getISTDateInputValue();

                const res = await fetch(
                    `https://api-gshf6jfmfq-uc.a.run.app/api/somerandomnumberappointments?date=${localDate}`
                );

                if (!res.ok) {
                    setAppointments([]);
                    return;
                }

                const data = await res.json();

                const list = Array.isArray(data)
                    ? data
                    : Array.isArray(data?.appointments)
                        ? data.appointments
                        : Array.isArray(data?.content)
                            ? data.content
                            : Array.isArray(data?.data)
                                ? data.data
                                : [];

                console.log("Today's appointments:", list);

                setAppointments(list);

            } catch (error) {

                console.error(
                    "Unable to load appointment notification",
                    error
                );

                setAppointments([]);
            }
        };

        loadTodayAppointments();

        // Refresh every minute
        const interval = setInterval(
            loadTodayAppointments,
            60000
        );

        return () => clearInterval(interval);

    }, []);

    const appointmentCount = appointments.length;

    const formatTime = (time) => {
        if (!time) return "Time not available";


        // Handles HH:mm or HH:mm:ss
        const [hours, minutes] = time.split(":");

        let hour = parseInt(hours, 10);

        const ampm = hour >= 12 ? "PM" : "AM";

        hour = hour % 12;
        hour = hour === 0 ? 12 : hour;

        return `${hour}:${minutes} ${ampm}`;


    };


    return (
        <div className="appointment-notification">

            <button
                className="notification-button"
                onClick={() => setShowDropdown(!showDropdown)}
            >

                <Bell size={22} />

                {appointmentCount > 0 && (
                    <span className="notification-badge">
                        {appointmentCount}
                    </span>
                )}

            </button>

            {showDropdown && (

                <div className="notification-dropdown">

                    <div className="notification-header">
                        Today's Appointments
                    </div>

                    {appointments.length === 0 ? (

                        <div className="no-appointments">
                            No appointments today
                        </div>

                    ) : (

                        appointments.map((appointment) => (

                            <div
                                key={appointment.id}
                                className="appointment-item"
                            >

                                <div className="appointment-time">
                                    {formatTime(
                                        appointment.appointmentTime ||
                                        appointment.time
                                    )}

                                </div>

                                <div className="appointment-details">

                                    <strong>
                                        {appointment.customerName ||
                                            appointment.customer?.name ||
                                            "Customer"}
                                    </strong>

                                    <div>
                                        {appointment.petName ||
                                            appointment.pet?.name ||
                                            "Pet"}
                                    </div>

                                    <small>
                                        {appointment.appointmentType ||
                                            appointment.type ||
                                            "Appointment"}
                                    </small>

                                </div>

                            </div>

                        ))

                    )}

                </div>

            )}

        </div>
    );
};

export default AppointmentNotification;